import $ from 'jquery';

import FormUtils from 'chairisher/util/form';
import { submitForm } from 'chairisher/util/fetch';

/**
 * Product feedback modal: submit and validation error display.
 */
class ProductFeedbackModal {
    constructor() {
        this.modal = document.querySelector('.js-product-feedback-modal');
        this.form = this.modal?.querySelector('.js-product-feedback-form');
        this.openBtns = document.querySelectorAll('.js-send-feedback-btn');
        this.successEl = this.modal?.querySelector('.js-product-feedback-success');
    }

    initialize() {
        if (this.form) {
            this.bind();
        }
    }

    /**
     * Resets the form and clears validation state.
     */
    resetForm() {
        this.form.reset();
        FormUtils.clearFormErrors($(this.form));
        FormUtils.toggleSubmitButton($(this.form), false);
    }

    /**
     * Shows the feedback form.
     */
    showForm() {
        this.form.classList.remove('hidden');
        this.successEl.classList.add('hidden');
    }

    /**
     * Shows the success state after submit.
     */
    showSuccess() {
        this.form.classList.add('hidden');
        this.successEl.classList.remove('hidden');
    }

    bind() {
        this.openBtns.forEach((openBtn) => {
            openBtn.addEventListener('click', () => {
                // Keep message draft; reset email to default and clear validation state.
                this.form.elements.email.value = this.form.elements.email.defaultValue;
                FormUtils.clearFormErrors($(this.form));
                FormUtils.toggleSubmitButton($(this.form), false);
                this.showForm();
            });
        });

        // Clear only the edited field's error; re-enable submit after a failure.
        this.form.addEventListener('input', (e) => {
            FormUtils.setFormGroupErrorMessage($(e.target).closest('.js-form-group'), null);
            FormUtils.toggleSubmitButton($(this.form), false);
        });

        this.form.addEventListener('submit', async (e) => {
            e.preventDefault();
            FormUtils.clearFormErrors($(this.form));
            FormUtils.toggleSubmitButton($(this.form), true);

            try {
                await submitForm(this.form);
                this.resetForm();
                this.showSuccess();
            } catch (error) {
                FormUtils.clearFormErrors($(this.form));
                error.json?.errors?.forEach((fieldError) => {
                    if (fieldError.field) {
                        FormUtils.setFormGroupErrorMessage(
                            $(this.form).find(`.js-form-group.${fieldError.field}`),
                            fieldError.message,
                        );
                    }
                });
            }
        });
    }
}

export default ProductFeedbackModal;
